(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klik-our-works"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('klik-works')) {
    customElements.define('klik-works', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.cards = [...this.querySelectorAll('[data-work-item]')];
        this.filters = [...this.querySelectorAll('[data-filter]')];
        this.dialog = this.querySelector('[data-work-dialog]');
        this.dialogImage = this.querySelector('[data-dialog-image]');
        this.dialogTitle = this.querySelector('[data-dialog-title]');
        this.dialogLocation = this.querySelector('[data-dialog-location]');
        this.dialogCategory = this.querySelector('[data-dialog-category]');
        this.empty = this.querySelector('[data-empty]');
        this.previous = this.querySelector('[data-dialog-previous]');
        this.next = this.querySelector('[data-dialog-next]');
        this.closeButton = this.querySelector('[data-dialog-close]');
        this.visibleCards = [...this.cards];
        this.activeIndex = 0;
        this.lastTrigger = null;
        this.touchStartX = 0;
        this.filters.forEach((filter) => filter.addEventListener('click', () => this.setFilter(filter)));
        this.cards.forEach((card) => card.querySelector('[data-work-trigger]')?.addEventListener('click', (event) => this.open(card, event.currentTarget)));
        this.previous?.addEventListener('click', () => this.move(-1));
        this.next?.addEventListener('click', () => this.move(1));
        this.closeButton?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog?.addEventListener('close', () => this.onClose());
        this.dialog?.addEventListener('keydown', (event) => this.onKeydown(event));
        this.dialog?.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });
        this.dialog?.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - this.touchStartX;
          if (Math.abs(distance) > 52) this.move(distance > 0 ? -1 : 1);
        }, { passive: true });
        this.prepareReveals();
      }

      prepareReveals() {
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        }, { rootMargin: '120px 0px', threshold: 0.08 });
        this.cards.forEach((card) => this.observer.observe(card));
      }

      setFilter(selected) {
        const category = selected.dataset.filter;
        const update = () => {
          this.filters.forEach((filter) => {
            const active = filter === selected;
            filter.classList.toggle('is-active', active);
            filter.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.cards.forEach((card) => {
            card.hidden = category !== 'all' && card.dataset.category !== category;
          });
          this.visibleCards = this.cards.filter((card) => !card.hidden);
          if (this.empty) this.empty.hidden = this.visibleCards.length > 0;
        };
        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          document.startViewTransition(update);
        } else {
          update();
        }
      }

      open(card, trigger) {
        if (!this.dialog) return;
        this.visibleCards = this.cards.filter((item) => !item.hidden);
        this.activeIndex = Math.max(0, this.visibleCards.indexOf(card));
        this.lastTrigger = trigger;
        this.show(this.activeIndex);
        this.bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
      }

      show(index) {
        if (!this.visibleCards.length) return;
        this.activeIndex = (index + this.visibleCards.length) % this.visibleCards.length;
        const trigger = this.visibleCards[this.activeIndex].querySelector('[data-work-trigger]');
        if (!trigger) return;
        const translatedTitle = trigger.querySelector('.klik-works__card-copy strong')?.textContent.trim();
        const translatedLocation = trigger.querySelector('.klik-works__location')?.textContent.trim();
        const translatedCategory = trigger.querySelector('.klik-works__category')?.textContent.trim();
        const update = () => {
          this.dialogImage.src = trigger.dataset.fullSrc;
          this.dialogImage.alt = trigger.dataset.alt || '';
          this.dialogTitle.textContent = translatedTitle || trigger.dataset.title || '';
          this.dialogLocation.textContent = translatedLocation || trigger.dataset.location || '';
          this.dialogCategory.textContent = translatedCategory || trigger.dataset.categoryLabel || '';
          const disabled = this.visibleCards.length < 2;
          this.previous.disabled = disabled;
          this.next.disabled = disabled;
        };
        if (document.startViewTransition && this.dialog.open && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          document.startViewTransition(update);
        } else {
          update();
        }
      }

      move(direction) {
        const rtl = document.documentElement.dir === 'rtl' || document.documentElement.lang.toLowerCase().startsWith('ar');
        this.show(this.activeIndex + (rtl ? direction * -1 : direction));
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1);
        }
      }

      onClose() {
        document.body.style.overflow = this.bodyOverflow || '';
        this.dialogImage.removeAttribute('src');
        this.lastTrigger?.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
